export default __webpack_public_path__ + "static/media/Felixibility_inactive.c6548f67.svg";